import { inject } from "@angular/core";
import { CanMatchFn, RedirectFunction, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { combineLatest, filter, map, take } from "rxjs";
import { sessionFeature } from "../../authentication/store/session.reducer";

export const conferenceRoomRedirect: RedirectFunction = ({ params }) => {
    const store = inject(Store);
    const router = inject(Router);
    const roomId = params["roomId"];

    return combineLatest([
        store.select(sessionFeature.selectIsSettled),
        store.select(sessionFeature.selectUser),
    ]).pipe(
        filter(([settled]) => settled),
        take(1),
        map(([, user]) => {
            if (!user) return router.createUrlTree(["/multi/room", roomId]);
            if (user.role === "owner")
                return router.createUrlTree([
                    "/owner/multiconference/room",
                    roomId,
                ]);
            return router.createUrlTree([
                "/dashboard/multiconference/room",
                roomId,
            ]);
        })
    );
};

export const anonymousConferenceRoomRedirect: CanMatchFn = (_route, segments) => {
    const store = inject(Store);
    const router = inject(Router);

    return combineLatest([
        store.select(sessionFeature.selectIsSettled),
        store.select(sessionFeature.selectUser),
    ]).pipe(
        filter(([settled]) => settled),
        take(1),
        map(([, user]) => {
            if (user && !user.isGuest) return false;

            const roomId = segments.at(-1)?.path;
            return roomId
                ? router.createUrlTree(["/dashboard/multi/room", roomId])
                : router.createUrlTree(["/dashboard/multi"]);
        })
    );
};
